export default {"src":"/_next/static/media/room-lets-icon.0b127dc9.svg","height":77,"width":86,"blurWidth":0,"blurHeight":0};